<template>
    <div class="map" id="map"></div>
</template>

<script>
export default{
    name: 'maps'
}
</script>